import { Sparkles } from "lucide-react";
import { AppIcon } from "~/components/ui/dynamic-icon";

export interface QuickActionIconProps {
  name: string;
  className?: string;
}

/**
 * Renders the quick action's `icon` field (a lucide-react icon name, e.g.
 * "chart-column"). Falls back to a generic icon for a name the backend sends
 * that this build of lucide doesn't recognize.
 */
export const QuickActionIcon = ({ name, className }: QuickActionIconProps) => (
  <AppIcon name={name} fallback={Sparkles} className={className} />
);
